import React, { useState, useEffect } from 'react';
import { CheckboxUI } from '../Interface';
import operationGroupService from '../../service/operationGroup.service';

const OperationUserLinks = ({ operationGroupUserLink, selectedValues, disabled, setRefetchTable }) => {
  const [links, setLinks] = useState(operationGroupUserLink);

  useEffect(() => {
    setLinks(operationGroupUserLink);
  }, [operationGroupUserLink]);

  const updateOperationGroupUserLink = (userId, isChecked) => {
    const updatedLinks = links.map((link) => (link.userId === userId ? { ...link, checked: isChecked } : link));
    setLinks(updatedLinks);

    operationGroupService.updateOperationGroupUserLink(selectedValues.id, userId).then(() => {
      setRefetchTable(true);
    });
  };

  return (
    <div>
      {links.map((userLink) => (
        <div key={userLink.userId}>
          <CheckboxUI
            sx={{ margin: 0, padding: '0.2rem' }}
            disabled={disabled}
            onChange={(e) => updateOperationGroupUserLink(userLink.userId, e.target.checked)}
            checked={userLink.checked || false}
          />
          {userLink.nickName}
        </div>
      ))}
    </div>
  );
};

export default OperationUserLinks;
